// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header___lrS5M4qGH{white-space:nowrap}`, "",{"version":3,"sources":["webpack://./src/components/copilotDropdown/components/header/copilotDropdownHeader.module.scss"],"names":[],"mappings":"AAAA,oBACE,kBAAA","sourcesContent":[".header {\n  white-space: nowrap;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": `header___lrS5M4qGH`
};
export default ___CSS_LOADER_EXPORT___;
